// import deployedContracts from '../../../contracts/deployed-contracts.json';
// import StarChallenge from '../../../contracts/artifacts/contracts/StarChallenge.sol/StarChallenge.json';
// import StarReward from '../../../contracts/artifacts/contracts/StarReward.sol/StarReward.json';
// import StarOFToken from '../../../contracts/artifacts/contracts/StarOFToken.sol/StarOFToken.json';
// import StarPoint from '../../../contracts/artifacts/contracts/StarPoint.sol/StarPoint.json';
// import StarPool from '../../../contracts/artifacts/contracts/StarPool.sol/StarPool.json';
// import StarTier from '../../../contracts/artifacts/contracts/StarTier.sol/StarTier.json';

// ETERNITY MAINNET
// const network = 'ARBITRUM_V2_MAINNET';
import StarPool from '../../../contracts-upgradeable/deployments/ARBITRUM_V2_MAINNET/StarPool.json';
import StarReward from '../../../contracts-upgradeable/deployments/ARBITRUM_V2_MAINNET/StarReward.json';
import StarTier from '../../../contracts-upgradeable/deployments/ARBITRUM_V2_MAINNET/StarTier.json';
import StarChallenge from '../../../contracts-upgradeable/deployments/ARBITRUM_V2_MAINNET/StarChallenge.json';
import StarPoint from '../../../contracts-upgradeable/deployments/ARBITRUM_V2_MAINNET/StarPoint.json';
import StarStaking from '../../../contracts/deployments/ETHEREUM_V2_MAINNET/StarOFTokenLock.json';
import StarOFToken from '../../../contracts/deployments/ETHEREUM_V2_MAINNET/StarOFToken.json';

export const environment = {
  passkeyEnabled: false,
  production: true,
  cognitoClientId: '1b6jn0n1o2ss5d9jjourh9lfd8',
  reownProjectId: '70638f0963b753fa034452313c84da67',
  apiUrl: `https://api.sponstar.io/`,
  siteUrl: `https://www.sponstar.io/`,
  assetsUrl: `https://www.sponstar.io/`,
  googleClientId: '21768675305-iqd9ug8coh8c3gpg5e8vv8lkspg8pgcd.apps.googleusercontent.com',
  authGoogle: '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',
  gatewayUrl: 'https://ms.sponstar.io/',
  zeroDev: {
    projectId: '7712e055-2d8e-41e5-bf62-efe757735fa8',
    rpcUrl: 'https://rpc.zerodev.app/api/v3/7712e055-2d8e-41e5-bf62-efe757735fa8/chain/421614',
    passkeyServer: 'https://passkeys.zerodev.app/api/v3/7712e055-2d8e-41e5-bf62-efe757735fa8',
  },
  rpcAddress: 'https://arb-mainnet.g.alchemy.com/v2/S7YIYn4BsINlC4U3oWl0Htm_Ia4OGmOF',
  blockExplorerUrl: `https://arbiscan.io/`,
  alchemyApiKey: 'S7YIYn4BsINlC4U3oWl0Htm_Ia4OGmOF',
  alchemyPolicyId: 'd8f925f7-03ad-4b04-9c3d-5fc2d17858ce',
  contracts: {
    StarPool: { abi: StarPool.abi, address: StarPool.address },
    StarReward: { abi: StarReward.abi, address: StarReward.address },
    StarTier: { abi: StarTier.abi, address: StarTier.address },
    StarChallenge: { abi: StarChallenge.abi, address: StarChallenge.address },
    StarPoint: { abi: StarPoint.abi, address: StarPoint.address },
    StarStaking: { abi: StarStaking.abi, address: StarStaking.address },
    StarOFToken: { abi: StarOFToken.abi, address: StarOFToken.address },
  },
};
